// extracted by mini-css-extract-plugin
export var examples = "examples-module--examples--2UWQy";
export var examplesSection = "examples-module--examples-section--1Fp7n";
export var examplesTable = "examples-module--examples-table--gCNea";
export var examplesDecorationObject = "examples-module--examples-decoration-object--1mSa3";
export var examplesDecorationGrad1 = "examples-module--examples-decoration-grad1--1PFmI";
export var examplesFooter = "examples-module--examples-footer--10KxF";